const testimonials = [
  {
    name: "Dr. Amanda K.",
    location: "UNL Faculty, Lincoln",
    rating: 5,
    text: "I had a neuroscience conference in Geneva with three weeks notice. My passport was sitting in my desk drawer expired — I hadn't traveled internationally since before COVID. Fast Passport Center had my renewal processed and back in six business days. Presented my research on schedule. Absolutely recommend to every UNL faculty member.",
    service: "Passport Renewal",
  },
  {
    name: "Connor M.",
    location: "UNL Student, Lincoln",
    rating: 5,
    text: "I got accepted into a study-abroad program in Prague with five weeks before orientation. Never had a passport before. Fast Passport Center walked me through exactly where to go for my acceptance clerk appointment and reviewed all my paperwork. Had my passport in eight business days. Made my flight. The team was incredibly patient with a first-timer.",
    service: "New Passport",
  },
  {
    name: "Sarah & David L.",
    location: "Seward, NE",
    rating: 5,
    text: "We planned a family reunion in Germany for over a year, then realized two weeks before that our teenage son's passport had expired and our youngest never had one. Fast Passport Center guided us through the child passport process, reviewed everything, and we had both in seven business days. Made our flights out of Lincoln Airport without any drama.",
    service: "Family Passport Services",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function LincolnTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Lincoln &amp; Southeast Nebraska Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from UNL students, faculty, and Southeast Nebraska families who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}